import clsx from 'clsx';
import Structure from 'components/corporatiu/Structure';
import __isEmpty from 'lodash/isEmpty';
import styles from './contenidor.module.scss';

export default function Contenidor(props) {
    const { tipus, estil, className, condicio, tag = 'div', id } = props;
    let TagSeo = tag;

    const styleContenidor = clsx(
        styles.contenidor,
        tipus && styles[tipus],
        estil && styles[estil],
        !__isEmpty(className) && className
    );

    if (condicio === '') return <></>;

    const getContent = () => {
        if (!__isEmpty(props?.children)) {
            return props.children;
        } else {
            return <Structure {...props} />;
        }
    };

    return (
        <TagSeo className={styleContenidor} id={id}>
            {getContent()}
        </TagSeo>
    );
}
